/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import { Box } from '@mantine/core';

// Components
import { Select, Text } from '@components/atoms';

// Styles
import classes from './Step1.module.css';

// Utils
import { convertArrayToLabelValue } from '@utils/functions';

// APIs
import { useProducers } from 'shared/api/get-producers';

// Store
import useStore from '@store/index';

// I18n
import { useTranslation } from 'react-i18next';

// Mantine forms
import { UseFormReturnType } from '@mantine/form';
import { useEffect } from 'react';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const Step1 = (props: {
	form: UseFormReturnType<
		{
			name: string;
			brand: string;
			tag: string;
			quantity: number;
			startDate: null;
			endDate: null;
		},
		(values: {
			name: string;
			brand: string;
			tag: string;
			quantity: number;
			startDate: null;
			endDate: null;
		}) => {
			name: string;
			brand: string;
			tag: string;
			quantity: number;
			startDate: null;
			endDate: null;
		}
	>;
	onCancel: () => void;
	onBack: () => void;
}) => {
	/* ********************************** Hooks ********************************* */

	const { data: producers } = useProducers();
	const {
		setProductionsStartMintsProducer,
		setProductionsStartMintsSelectedRecords,
	} = useStore();
	const { t } = useTranslation();
	/* ******************************** HELPERS *********************************** */

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { onChange: onChangeProducer, ...producerProps } =
		props.form.getInputProps('producer');

	const handleChangeProducer = (value: string) => {
		props.form.setFieldValue('producer', value);
		setProductionsStartMintsProducer(value);
	};

	useEffect(() => {
		setProductionsStartMintsSelectedRecords([]);
	}, []);

	/* ******************************** RENDERING ******************************* */
	return (
		<Box className={classes.container}>
			<form
				className={classes.containerForm}
				onSubmit={props.form.onSubmit(() => {})}
			>
				<Text className={classes.subTitleForm}>
					{t(
						'productions.selectProducerToStartMintProductions'
					)}
				</Text>

				<Box className={classes.row}>
					<Box className={classes.containerInput}>
						<Select
							visibleFrom="xxl"
							size="lg"
							label={t('global.producer')}
							withAsterisk
							data={convertArrayToLabelValue(producers)}
							placeholder={t(
								'placeholders.selectProducer'
							)}
							onChange={handleChangeProducer}
							{...producerProps}
						/>
						<Select
							hiddenFrom="xxl"
							size="sm"
							label={t('global.producer')}
							withAsterisk
							data={convertArrayToLabelValue(producers)}
							placeholder={t(
								'placeholders.selectProducer'
							)}
							onChange={handleChangeProducer}
							{...producerProps}
						/>
					</Box>
				</Box>
			</form>
		</Box>
	);
};
